module.exports = __webpack_public_path__ + "img/growcify-website-12-banner.17edaf16.png";